import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { shouldUpdate } from 'recompose';
import ClinicianHeader from './../../../containers/DailyPlanning/ClinicianHeader/ClinicianHeaderContainer';
import posting from '../../../propTypes/entities/posting';
import { appSettingsPropTypes, appSettingsDefault } from '../../../propTypes/entities/appSettings';
import globals from '../../../globals/communityGlobals';
import { AssignmentType, TreatmentInstanceStatus } from '../../../enums';

const CliniciansList = ({ postings, selectedDate, appSettings }) => {
  function parseDate(date) {
    return moment(date || new Date(0)).utcOffset(0, true);
  }

  function findStartedAssignment(assigments) {
    return assigments.filter(x => !!x).find(a => a.treatmentInstanceStatus === TreatmentInstanceStatus.InProgress);
  }

  function removeNpaAssignments(assigments) {
    return assigments.filter(x => !!x && x.assignmentType === AssignmentType.PatientAssignment);
  }

  function getAssignmentsBeforeCurrTime(assigments) {
    const nowAt = globals.now.utcOffset(0, true);
    return assigments.filter(a => !!a && parseDate(a.visitStarted || a.startDate).isBefore(nowAt));
  }

  const currAssignment = assigments => {
    const assigmentStarted = findStartedAssignment(assigments);
    if (assigmentStarted !== undefined) return assigmentStarted;

    const assigmentBeforeCurrTime = getAssignmentsBeforeCurrTime(assigments);
    if (assigmentBeforeCurrTime.length === 0) return assigments[0];

    for (let i = 0; i < assigmentBeforeCurrTime.length; i += 1) {
      if (assigmentBeforeCurrTime[i].visitStarted === null) {
        return assigmentBeforeCurrTime[i];
      }
    }
    return assigmentBeforeCurrTime[assigmentBeforeCurrTime.length - 1];
  };

  function sortAssigments(a, b) {
    return parseDate(a.startDate) - parseDate(b.startDate);
  }

  const cliniciansList = postings.map(el => {
    const assigments = el.availabilities.reduce((prev, curr) => prev.concat(curr.assignments), []);
    assigments.sort((a, b) => sortAssigments(a, b));

    const onlyPatientAssignments = removeNpaAssignments(assigments);

    const assigment =
      onlyPatientAssignments.length === 0
        ? { visitStatus: null, offset: null }
        : currAssignment(onlyPatientAssignments);

    return (
      <ClinicianHeader
        key={`postingItem${el.id}`}
        clinician={el.clinician}
        ragCapacity={el.ragCapacity}
        appSettings={appSettings}
        grade={el.grade}
        workingTime={el.workingTime}
        availableTime={el.availableTime}
        assignedTime={el.assignedTime}
        status={assigment.visitStatus}
        offset={assigment.visitOffset}
        differentOrder={el.differentOrder}
        selectedDate={selectedDate}
      />
    );
  });
  return (
    <ul className="clinician-list">
      {cliniciansList}
      <li className="list-item footer" />
    </ul>
  );
};

CliniciansList.defaultProps = {
  appSettings: appSettingsDefault,
  postings: [],
  selectedDate: '',
};

CliniciansList.propTypes = {
  postings: PropTypes.arrayOf(posting),
  appSettings: appSettingsPropTypes.isRequired,
  selectedDate: PropTypes.string,
};

const checkPropsChange = (props, nextProps) =>
  props.selectedDate !== nextProps.selectedDate || props.postings !== nextProps.postings;

export default shouldUpdate(checkPropsChange)(CliniciansList);
